export default class ListSectionModel<T> {
  public key: string
  public value: Array<T>
  public icon?: string

  public constructor(key: string, value: Array<T>, icon?: string) {
    this.key = key
    this.value = value
    this.icon = icon
  }
}
